exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-dag-markdown-remark-frontmatter-slug-js": () => import("./../../../src/pages/dag/{MarkdownRemark.frontmatter__slug}.js" /* webpackChunkName: "component---src-pages-dag-markdown-remark-frontmatter-slug-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

